import { Link, useLocation } from "react-router-dom";

const Breadcrumbs = () => {
  const { pathname } = useLocation();
  const pathnames = pathname.split("/").filter(Boolean);

  // Add all route segments that should not be clickable and their children
  const nonClickableSegments = ["edit", "details"];

  return (
    <nav className="text-sm text-gray-600">
      <ul className="flex items-center gap-2">
        <li>
          <Link to="/" className="text-orange-500 cursor-pointer hover:underline">
            Home
          </Link>
        </li>

        {pathnames.map((segment, index) => {
          const routeTo = "/" + pathnames.slice(0, index + 1).join("/");
          const isLast = index === pathnames.length - 1;
          const label = segment.charAt(0).toUpperCase() + segment.slice(1);

          // Detect if the current or previous segment is in nonClickableSegments
          const isInsideNonClickable =
            nonClickableSegments.includes(segment) ||
            nonClickableSegments.includes(pathnames[index - 1]);

          // Disable click if it's the last segment OR it's under a non-clickable section
          const clickable = !isLast && !isInsideNonClickable;

          return (
            <li key={routeTo} className="flex items-center gap-2">
              <span>/</span>
              {clickable ? (
                <Link
                  to={routeTo}
                  className="text-orange-500 cursor-pointer hover:underline"
                >
                  {label}
                </Link>
              ) : (
                <span className="text-gray-500">{label}</span>
              )}
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

export default Breadcrumbs;
